import StoreForm, { MockUpForm } from "@components/PurchaseForms";
import StepForm from "@components/StepForm";
import StoreLayout from "@components/StoreLayout";
import { getMockupData } from "@constants/mockup/mockupFormDefaults";
import Accessories from "@pages/Accessories";
import Licenses from "@pages/Licenses";
import PurchaseComplete from "@pages/PurchaseComplete";
import TestAllAPIs from "@pages/TestAllAPIs";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Route, Routes, useParams } from "react-router-dom";

// Wrapper component to extract country ID from route params and apply mockup data
function MockupWithCountry() {
  const { countryId } = useParams();
  const methods = useFormContext();

  useEffect(() => {
    const mockupData = getMockupData(countryId);
    methods.reset(mockupData);
  }, [countryId, methods]);

  return <StepForm />;
}

function App() {
  return (
    <Routes>
      {import.meta.env.MODE === "development" && <Route path="/test" element={<TestAllAPIs />} />}

      <Route element={<StoreLayout />}>
        <Route path="/" element={<StoreForm />} />
        <Route path="/licenses" element={<Licenses />} />
        <Route path="/accessories" element={<Accessories />} />
        {import.meta.env.MODE === "development" && (
          <>
            <Route path="/mockup" element={<MockUpForm />} />
            <Route path="/mockup/:countryId" element={<MockupWithCountry />} />
          </>
        )}
        <Route path="purchase-complete" element={<PurchaseComplete />} />
      </Route>
    </Routes>
  );
}

export default App;
